import { AxiosError, isAxiosError } from 'axios';

export const hasStatus = (err: unknown, status: number) =>
  isAxiosError(err) && err.response?.status === status;

// On a 5xx the API fills errors[] with the caught exception's own message, so
// only 4xx bodies are safe to show a user.
type ApiErrorBody = {
  errors?: Array<{ message?: string }>;
  message?: string;
};

export const serverMessage = (err: unknown): string | undefined => {
  const response = (err as AxiosError<ApiErrorBody> | null | undefined)
    ?.response;
  const status = response?.status;
  if (
    !response ||
    typeof status !== 'number' ||
    status < 400 ||
    status >= 500
  ) {
    return undefined;
  }

  const { data } = response;
  const fromValidation = Array.isArray(data?.errors)
    ? data.errors
        .map((e: { message?: string }) => e?.message)
        .filter(Boolean)
        .join(' ')
    : '';
  return fromValidation || data?.message || undefined;
};
